import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  LATEST_ANTHROPIC_MODEL,
  LATEST_ANTHROPIC_MODEL_SUPPORTS_THINKING,
} from '@shared/models';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const DEFAULT_PARAMETRIC_MODEL = LATEST_ANTHROPIC_MODEL;
export const DEFAULT_PARAMETRIC_MODEL_SUPPORTS_THINKING =
  LATEST_ANTHROPIC_MODEL_SUPPORTS_THINKING;
